import { graphql } from "@/gql"


export const teamMembersAndOwnersQuery = graphql(/* GraphQL */`
  query TeamMembersAndOwnersQuery($companyId: ID!, $first: Int!, $page: Int, $search: String) {
    company(id: $companyId) {
      teamMembersAndOwners(first: $first, page: $page, search: $search) {
        data {
          ...UserFragment
        }
        paginatorInfo {
          hasMorePages
          currentPage
        }
      }
    }
  }
`)

export const getAllUsersQuery = graphql(/* GraphQL */`
  query GetUserGroup($id: ID!, $usersFirst: Int!, $usersPage: Int) {
    userGroup(id: $id) {
      ...UsersFragment
    }
  }
`)

export const userGroupsQuery = graphql(/* GraphQL */`
  query UserGroups(
    $accounts: [ID!]
    $groupFirst: Int!
    $groupPage: Int
    $usersFirst: Int!
    $usersPage: Int
    $search: String
  ) {
    userGroups(accounts: $accounts, first: $groupFirst, page: $groupPage, search: $search) {
      paginatorInfo {
        hasMorePages
        currentPage
        firstItem
        lastItem
        perPage
        total
      }
      data {
        ...UserGroupFragment
        ...UsersFragment
      }
    }
  }
`)
